"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerStore = void 0;
var customer_1 = require("./customer");
Object.defineProperty(exports, "customerStore", { enumerable: true, get: function () { return customer_1.customerStore; } });
//# sourceMappingURL=index.js.map